import api from '../../apis/api';
import React from 'react';
import { Segment, Card, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import { ErrorToast } from '../Toasters';
import CardDetails from './CardDetails';

export default class OutstandingTickets extends React.Component {

    static contextType = UserContext

    state = {
        tickets: [],
        selected: null,
        modal: false
    }

    getOutStandingTickets = () => {
        api.get('/requests/outstanding').then(r => {
            this.setState({tickets: r.data})
        }).catch(err => ErrorToast(err))
    }

    componentDidMount(){
        this.getOutStandingTickets()
    }

    render(){
        if(this.state.tickets.length !== 0){
            const TYPEDICT = {
                "change": "Change",
                "access": "Access",
                "tca_rm": "TCA / RM"
            }
            let baseLink = '/tickets/details'

            return (<Segment>
                <h1>Oustanding Requests</h1>
                <Card.Group itemsPerRow={3}>
                {this.state.tickets.map(t => 
                    <Card raised key={t.id}>
                        <Card.Content>
                            <Card.Header><Button color="orange" inverted as={Link} to={`${baseLink}/${t.number}`} target="_blank">{t.number}</Button> {TYPEDICT[t.type]}</Card.Header>
                            <CardDetails ticket={t} callback={this.getOutStandingTickets}/>
                        </Card.Content>
                    </Card>
                )}
                </Card.Group>
                
            </Segment>)
        } else {
            return <div>There are no oustanding tickets</div>
        }
    }
}